import React from 'react';

// tslint:disable:max-line-length
const TrelloIcon = (props) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill={props.color || 'currentColor'}
      fillRule="evenodd"
      d="M0 2v12c0 .552.195 1.023.586 1.414.39.39.862.586 1.414.586h12c.552 0 1.023-.195 1.414-.586.39-.39.586-.862.586-1.414V2c0-.552-.195-1.023-.586-1.414A1.927 1.927 0 0 0 14 0H2C1.448 0 .977.195.586.586.196.976 0 1.448 0 2zm2 1a.96.96 0 0 1 .29-.71A.966.966 0 0 1 3 2h3a.96.96 0 0 1 .71.29A.96.96 0 0 1 7 3v9a.966.966 0 0 1-.29.71A.966.966 0 0 1 6 13H3a.966.966 0 0 1-.71-.29A.966.966 0 0 1 2 12V3zm8-1h3a.96.96 0 0 1 .71.29A.96.96 0 0 1 14 3v5.766a.97.97 0 0 1-.29.703.953.953 0 0 1-.71.297h-3a.953.953 0 0 1-.71-.297.974.974 0 0 1-.29-.703V3a.96.96 0 0 1 .29-.71A.966.966 0 0 1 10 2z"
    />
  </svg>
);
// tslint:enable:max-line-length

export default TrelloIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/TrelloIcon.js